var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vframe"},[_c('iframe',{staticClass:"video-preview-iframe",attrs:{"id":"videoPreIfm","src":_vm.src,"frameborder":"0","scrolling":"0","width":"100%","height":"100%","allow":"fullscreen"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }